import React from 'react';
import { useNavigate } from 'react-router-dom';
import { churchInfo } from '../data/mock';
import { Button } from '../components/ui/button';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-navy-900 flex flex-col items-center justify-center p-6">
      {/* Logo */}
      <div className="flex flex-col items-center text-center">
        <div className="w-32 h-32 rounded-full bg-white p-1 shadow-2xl mb-8">
          <img
            src={churchInfo.logo}
            alt={churchInfo.name}
            className="w-full h-full object-contain rounded-full"
          />
        </div>
        
        {/* Church Name */}
        <h1 className="text-3xl md:text-4xl font-bold text-white mb-3 leading-tight text-center">
          Second Missionary<br />Baptist Church
        </h1>
        
        {/* Tagline */}
        <p className="text-tan-400 text-lg md:text-xl italic mb-12">
          Where God gets ALL the Glory
        </p>
        
        {/* Enter Button */}
        <Button
          onClick={() => navigate('/login')}
          className="bg-tan-500 hover:bg-tan-600 text-white px-10 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 font-medium"
        >
          Click to Enter
        </Button>
      </div>
    </div>
  );
};

export default LandingPage;
